import { render, staticRenderFns } from "./anticiposAnterios.vue?vue&type=template&id=62ca5ef4"
import script from "./anticiposAnterios.vue?vue&type=script&lang=js"
export * from "./anticiposAnterios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports